import { render, staticRenderFns } from "./_footprint.vue?vue&type=template&id=fa76e836&scoped=true"
import script from "./_footprint.vue?vue&type=script&lang=js"
export * from "./_footprint.vue?vue&type=script&lang=js"
import style0 from "./_footprint.vue?vue&type=style&index=0&id=fa76e836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76e836",
  null
  
)

export default component.exports